// extracted by mini-css-extract-plugin
module.exports = {"freeText":"freeText_freeText__Jqz1d"};